import React from "react";
import styles from "./SpecsheetButtonBlue.module.css";

const SpecsheetButtonBlue = ({ children, handleClick, type }) => {
  return (
    <button className={styles.button} type={type} onClick={handleClick}>
      {children}
    </button>
  );
};

export default SpecsheetButtonBlue;
